import { createApp } from 'vue'
import Pop from '../pop.vue';
import MyI18n from '../plugins/my_i18n'
//import { createApp } from 'vue';
  /* eslint-disable no-new */

document.addEventListener('DOMContentLoaded', () => {
  const da = document.querySelector("#pop");
  
  // Create the Vue 3 app
  const cProps = {
    name: da.dataset.name,
    sign: da.dataset.sign,
    text: da.dataset.text,
    accept: da.dataset.accept,
    next: da.dataset.next
  }
  const app = createApp(Pop, cProps);
  // Use the i18n plugin (installed globally)
  app.use(MyI18n);

  // Mount the app to the #pop element
  app.mount('#pop');
});

/*
const app = createApp(
  {
    props: ['signURL'],
  },
  { signURL: 'Evan' }
  )
createApp(Pop).mount("#pop");
*/
